import { Notifications } from "@twilio/flex-ui";
import * as Flex from "@twilio/flex-ui";
import TaskService from "../../../utils/TaskRouterService";
import { NotificationIds } from "../flex-hooks/notifications/TransferResult";
import { removeInvitedParticipant } from "../helpers/inviteTracker";
import { CancelChatParticipantInviteActionPayload } from "../types/ActionPayloads";

export const name = "CancelChatParticipantInvite";

export const handle = async (payload: CancelChatParticipantInviteActionPayload) => {
  const { conversation, invitesTaskSid } = payload;
  console.log("handleCancelChatParticipantInvite", conversation, invitesTaskSid);

  try {
    const manager = Flex.Manager.getInstance();
    await new TaskService(manager).updateTaskAssignmentStatus(invitesTaskSid, "canceled");
    await removeInvitedParticipant(manager, conversation, invitesTaskSid);

    Notifications.showNotification(NotificationIds.ChatCancelParticipantInviteSuccess);
  } catch (error) {
    console.error("handleCancelChatParticipantInvite API request failed", error);
    Notifications.showNotification(NotificationIds.ChatCancelParticipantInviteFailed);
  }
};
